<template>
  <div>
    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import mixin from "../driver/mixin";

export default {
  mixins: [mixin],
  props: [
    'idx',
    'iswork',
  ],
  data() {
    return {
      menuIndex: '',
      menu: [],
      list: ['在职', '离职', '冻结'],
    };
  },
  methods: {
  },
  watch: {
    $route(to, from) {
      // console.log(from, to)
      if (to.params.idx !== from.params.idx) {
        this.menu = []
        this.list.map((v, i) => {
          const o = {
            name: v,
            path: `/staff/escort/table/${to.params.idx}/list/${i + 1}`,
          }
          this.menu.push(o)
        })
      }
      this.$nextTick(() => {
        // console.log(this.menuIndex)
        // this.menuIndex = this.$route.path
        // console.log(this.menuIndex)
        // console.log(this.menu)
      })
    },
  },
  mounted() {
    this.list.map((v, i) => {
      const o = {
        name: v,
        path: `/staff/escort/table/${this.idx}/list/${i + 1}`,
      }
      this.menu.push(o)
    })
    this.menuIndex = this.$route.path
    // console.log(this.menuIndex)
    // console.log(this.menu)
  },
};
</script>
